/**
 * Directive: resourceAvailability
 */
angular.module('acme.common.directive.resourceAvailability', [
  'acme.common.service.api',
  'acme.common.factory.gridState',
  'acme.common.directive.combobox',
  'acme.common.service.permissions',
  'acme.common.directive.resourceAvailability.constants',
  'acme.common.service.helpers',
  'acme.common.directive.resourceAvailabiilityGrid'
])
.directive('resourceAvailability', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceAvailability/resourceAvailability.tpl.html',
      scope: {
        eventId: '=',
        eventTemplateId: '=',
        privateSchedule: '=',
        resourcesList: '=',
        startTime: '=',
        startHour: '=',
        duration: '=',
        selectedResourcesList: '='
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: [
        '$scope',
        '$timeout',
        '$q',
        'ApiService',
        'HelpersService',
        'GridStateFactory',
        'AVAILABILITY',
        'DROPDOWN',
        function(
          $scope,
          $timeout,
          $q,
          ApiService,
          HelpersService,
          GridStateFactory,
          AVAILABILITY,
          DROPDOWN
        ) {

        $scope.resourceAvailability = {

          resourcesList: [],
          undoResourcesList: [],
          resourceItem: {},
          selectedResourceItem: {},
          selectedResourceRequest: false,
          selectedResourceRequestLabel: '',
          resourcesMeta: {
            available: {
              count: 0,
              status: AVAILABILITY.available.status,
              icon: AVAILABILITY.available.icon,
              label: AVAILABILITY.available.label
            },
            unavailable: {
              count: 0,
              status: AVAILABILITY.unavailable.status,
              icon: AVAILABILITY.unavailable.icon,
              label: AVAILABILITY.unavailable.label
            },
            unassign: {
              count: 0,
              status: AVAILABILITY.unassign.status,
              icon: AVAILABILITY.unassign.icon,
              label: AVAILABILITY.unassign.label
            }
          },

          resourcesRequestListgridState: new GridStateFactory(),
          gridState: new GridStateFactory(),

          editMode: false,
          dropdownClass: DROPDOWN.classes.view,

          startDateTime: new Date(),

          search: '',
          isLoaded: true,

          isAnchorLoaded: true,

          type: '',

          init: function() {
            this.type = ($scope.eventId) ? 'event' : 'template';
            this.initGrid();
            this.initWatchers();
            this.getResourceRequestsList();
          },

          initGrid: function() {
            this.gridState.setPropertyValue('sortField','resourceName');
            this.gridState.setPropertyValue('sortDirection','asc');
            this.gridState.setPropertyValue('pageSize','100');
          },

          initWatchers: function() {
            $scope.$on('$destroy', $scope.$watch('startTime', this.onStartTimeChange));
            $scope.$on('$destroy', $scope.$watch('startHour', this.onStartHourChange));
            $scope.$on('$destroy', $scope.$watchCollection('duration', this.onDurationChange));
            $scope.$on('$destroy', $scope.$watch('resourceAvailability.selectedResourceItem', this.onSelectedResourceItemChange));
            $scope.$on('ResourceAvailabiilityGrid::searchEnd', function() {
              $scope.resourceAvailability.isLoaded = true;
            });
          },

          getResourceRequestsList: function() {
            var self = $scope.resourceAvailability,
                props = {},
                list = [];

            if (self.type === 'event') {
              props = $.extend({
                eventId: $scope.eventId
              }, self.resourcesRequestListgridState.getGridState());

              ApiService.program.resources.requests.list(props).then(function(res) {
                $scope.resourcesList = res.data.payload.list;
                self.undoResourcesList = res.data.payload.list.slice();
                self.processResources($scope.resourcesList);
              });
            }

            if (self.type === 'template') {
              list = $scope.resourcesList.map(function(item){
                return {
                  resourceTemplateId: item.eventResource.resourceTemplateId,
                  resourceCategory: item.eventResource.resourceCategory,
                  resourceName: item.eventResource.resourceName,
                  resourceTemplateName: item.eventResource.type,
                  resourceId: item.eventResource.resourceId,
                  id: item.id
                };
              });

              $scope.resourcesList = list;
              self.undoResourcesList = $scope.resourcesList.slice();
              self.processResources($scope.resourcesList);
            }
          },

          query: function() {
            this.isLoaded = false;
            $scope.$broadcast('ResourceAvailabiilityGrid::search', { search: this.search, type: this.type });
          },

          processResources: function(resourcesList) {
            var self = $scope.resourceAvailability,
                promises = [],
                resourcesRequest = {},
                available = {},
                unavailable = {};

            self.setDateTime();

            $scope.$broadcast('ResourceAvailabiilityGrid::search', { search: this.search, type: this.type });

            resourcesList.forEach(function(item){

              if (item.resourceId) {
                resourcesRequest[item.resourceId] = item;

                if (self.type === 'event') {
                  promises.push(ApiService.resource.assignment.request($.extend({
                    id: item.id,
                    startTime: moment(self.startDateTime).format(),
                    durationHour: '' + $scope.duration.hour,
                    durationMinutes: '' + $scope.duration.minutes,
                    match: 'true',
                    available: 'false',
                    resourceOwnerId: item.resourceOwnerId
                  },
                  $scope.resourceAvailability.gridState.getGridState())).then(function(res) {
                    for (var i = 0; i < res.data.payload.list.length; i++) {
                      if (resourcesRequest.hasOwnProperty(res.data.payload.list[i].resourceId)) {
                        if (res.data.payload.list[i].available && !res.data.payload.list[i].conflicts) {
                          available[res.data.payload.list[i].resourceId] = res.data.payload.list[i];
                        } else {
                          unavailable[res.data.payload.list[i].resourceId] = res.data.payload.list[i];
                        }
                      }
                    }
                  }));
                } else if (self.type === 'template') {
                  promises.push(ApiService.resource.assignment.resourceRequest($.extend({
                    resourceTemplateId: item.resourceTemplateId,
                    resourceCategory: item.resourceCategory,
                    startTime: moment(self.startDateTime).format(),
                    durationHour: '' + $scope.duration.hour,
                    durationMinutes: '' + $scope.duration.minutes,
                    match: 'true',
                    available: 'false'
                  },
                  $scope.resourceAvailability.gridState.getGridState())).then(function(res) {
                    for (var i = 0; i < res.data.payload.list.length; i++) {
                      if (resourcesRequest.hasOwnProperty(res.data.payload.list[i].resourceId)) {
                        if (res.data.payload.list[i].available && !res.data.payload.list[i].conflicts) {
                          available[res.data.payload.list[i].resourceId] = res.data.payload.list[i];
                        } else {
                          unavailable[res.data.payload.list[i].resourceId] = res.data.payload.list[i];
                        }
                      }
                    }
                  }));
                }
              }
            });

            $q.all(promises).then(function() {
              self.resourcesList = resourcesList.map(function(item) {
                item.name = item.resourceName || AVAILABILITY.unassign.label;
                item.label = item.resourceTemplateName;

                if (!item.resourceId) {
                  item.status = self.resourcesMeta.unassign.status;
                  item.statusIcon = self.resourcesMeta.unassign.icon;
                  item.statusLabel = self.resourcesMeta.unassign.label;
                } else {
                  if (available.hasOwnProperty(item.resourceId)) {
                    item.status = self.resourcesMeta.available.status;
                    item.statusIcon = self.resourcesMeta.available.icon;
                    item.statusLabel = self.resourcesMeta.available.label;
                  } else if(unavailable.hasOwnProperty(item.resourceId)) {
                    item.status = self.resourcesMeta.unavailable.status;
                    item.statusIcon = self.resourcesMeta.unavailable.icon;
                    item.statusLabel = self.resourcesMeta.unavailable.label;
                  }
                }

                return item;
              });

              if (self.resourcesList.length) {
                self.processSummary();

                if (!self.selectedResourceRequest) {
                  self.selectedResourceRequest = self.resourcesList[0];
                } else {
                  self.resourcesList.forEach(function(item) {
                    if (item.id === self.selectedResourceRequest.id) {
                      self.selectedResourceRequest.status = item.status;
                      self.selectedResourceRequest.statusIcon = item.statusIcon;
                      self.selectedResourceRequest.statusLabel = item.statusLabel;
                    }
                  });
                }

                self.setselectedResourceRequest();
              }
            });
          },

          processSummary: function() {
            var self = $scope.resourceAvailability;

            self.resetSummary();

            self.resourcesList.forEach(function(item) {
              switch (item.status) {
                case self.resourcesMeta.unassign.status:
                  self.resourcesMeta.unassign.count++;
                  break;
                case self.resourcesMeta.unavailable.status:
                  self.resourcesMeta.unavailable.count++;
                  break;
                default:
                  self.resourcesMeta.available.count++;
              }
            });
          },

          resetSummary: function() {
            var self = $scope.resourceAvailability;

            self.resourcesMeta.available.count = 0;
            self.resourcesMeta.unavailable.count = 0;
            self.resourcesMeta.unassign.count = 0;
          },

          setDateTime: function() {
            $scope.resourceAvailability.startDateTime = moment($scope.startTime.setHours($scope.startHour.getHours(), $scope.startHour.getMinutes(), 0));
          },

          setselectedResourceRequest: function() {
            var self = $scope.resourceAvailability;
            self.selectedResourceRequestLabel = this.selectedResourceRequest.resourceTemplateName;
            self.selectedResourceRequestIcon = this.selectedResourceRequest.statusIcon;

            self.resourceItem = this.selectedResourceRequest;
            if (this.selectedResourceRequest.status !== AVAILABILITY.available.status) {
              self.editResourceRequest();
            }
          },

          editResourceRequest: function() {
            this.editMode = true;
            $('.' + DROPDOWN.classes.view).addClass(DROPDOWN.classes.edit);
          },

          replaceResourceList: function(selectedResourceRequestCopy) {
            var self = $scope.resourceAvailability;

            for(var i = 0, length = self.resourcesList.length; i < length; i++) {

              if (self.resourcesList[i] === self.selectedResourceRequest) {
                self.resourcesList[i] = selectedResourceRequestCopy;

                if (self.resourcesList[i].id === self.undoResourcesList[i].id) {
                  if (self.resourcesList[i].resourceId !== self.undoResourcesList[i].resourceId) {
                    self.resourcesList[i].changed = true;
                    self.resourcesList[i].undo = i;
                  } else {
                    self.resourcesList[i].changed = false;
                    self.resourcesList[i].undo = false;
                  }
                }

                self.selectedResourceRequest = self.resourcesList[i];
                self.selectedResourceRequestIcon = self.selectedResourceRequest.statusIcon;
              }
            }
          },

          undoSelectedResourceRequest: function() {
            var self = $scope.resourceAvailability,
                selectedResourceRequestCopy = $.extend({}, self.selectedResourceRequest),
                undoItem = self.undoResourcesList[selectedResourceRequestCopy.undo];

            if (self.isAnchorLoaded) {
              self.isAnchorLoaded = false;

              undoItem.name = undoItem.resourceName || AVAILABILITY.unassign.label;
              undoItem.label = undoItem.resourceTemplateName;

              if (!undoItem.resourceId) {
                undoItem.status = self.resourcesMeta.unassign.status;
                undoItem.statusIcon = self.resourcesMeta.unassign.icon;
                undoItem.statusLabel = self.resourcesMeta.unassign.label;

                self.resourcesList[selectedResourceRequestCopy.undo] = undoItem;

                self.selectedResourceRequest = self.resourcesList[selectedResourceRequestCopy.undo];
                self.selectedResourceRequestLabel = self.selectedResourceRequest.label;
                self.selectedResourceRequestIcon = self.selectedResourceRequest.statusIcon;

                $scope.$broadcast('DataGrid::clearSelection');
                $scope.$broadcast('ResourceAvailabiilityGrid::setSelection', self.selectedResourceRequest);

                self.isAnchorLoaded = true;

              } else {

                if (this.type === 'event') {
                  ApiService.resource.assignment.request($.extend({
                    id: undoItem.id,
                    startTime: moment(self.startDateTime).format(),
                    durationHour: '' + $scope.duration.hour,
                    durationMinutes: '' + $scope.duration.minutes,
                    match: 'true',
                    available: 'false',
                    resourceOwnerId: undoItem.resourceOwnerId
                  },
                  $scope.resourceAvailability.gridState.getGridState())).then(function(res) {
                    for (var i = 0; i < res.data.payload.list.length; i++) {
                      if (undoItem.resourceId === res.data.payload.list[i].resourceId) {
                        if (res.data.payload.list[i].available && !res.data.payload.list[i].conflicts) {
                          undoItem.status = self.resourcesMeta.available.status;
                          undoItem.statusIcon = self.resourcesMeta.available.icon;
                          undoItem.statusLabel = self.resourcesMeta.available.label;
                        } else {
                          undoItem.status = self.resourcesMeta.unavailable.status;
                          undoItem.statusIcon = self.resourcesMeta.unavailable.icon;
                          undoItem.statusLabel = self.resourcesMeta.unavailable.label;
                        }
                      }
                    }

                    self.resourcesList[selectedResourceRequestCopy.undo] = undoItem;

                    self.selectedResourceRequest = self.resourcesList[selectedResourceRequestCopy.undo];
                    self.selectedResourceRequestLabel = self.selectedResourceRequest.label;
                    self.selectedResourceRequestIcon = self.selectedResourceRequest.statusIcon;

                    $scope.$broadcast('DataGrid::clearSelection');
                    $scope.$broadcast('ResourceAvailabiilityGrid::setSelection', self.selectedResourceRequest);

                    self.isAnchorLoaded = true;
                  }, function() {});
                }

                if (this.type === 'template') {
                  ApiService.resource.assignment.resourceRequest($.extend({
                    resourceTemplateId: undoItem.resourceTemplateId,
                    resourceCategory: undoItem.resourceCategory,
                    startTime: moment(self.startDateTime).format(),
                    durationHour: '' + $scope.duration.hour,
                    durationMinutes: '' + $scope.duration.minutes,
                    match: 'true',
                    available: 'false'
                  },
                  $scope.resourceAvailability.gridState.getGridState())).then(function(res) {
                    for (var i = 0; i < res.data.payload.list.length; i++) {
                      if (undoItem.resourceId === res.data.payload.list[i].resourceId) {
                        if (res.data.payload.list[i].available && !res.data.payload.list[i].conflicts) {
                          undoItem.status = self.resourcesMeta.available.status;
                          undoItem.statusIcon = self.resourcesMeta.available.icon;
                          undoItem.statusLabel = self.resourcesMeta.available.label;
                        } else {
                          undoItem.status = self.resourcesMeta.unavailable.status;
                          undoItem.statusIcon = self.resourcesMeta.unavailable.icon;
                          undoItem.statusLabel = self.resourcesMeta.unavailable.label;
                        }
                      }
                    }

                    self.resourcesList[selectedResourceRequestCopy.undo] = undoItem;

                    self.selectedResourceRequest = self.resourcesList[selectedResourceRequestCopy.undo];
                    self.selectedResourceRequestLabel = self.selectedResourceRequest.label;
                    self.selectedResourceRequestIcon = self.selectedResourceRequest.statusIcon;

                    $scope.$broadcast('DataGrid::clearSelection');
                    $scope.$broadcast('ResourceAvailabiilityGrid::setSelection', self.selectedResourceRequest);

                    self.isAnchorLoaded = true;
                  }, function() {});
                }
              }
            }
          },

          onResourceChange: function() {
            $scope.resourceAvailability.setselectedResourceRequest();
          },

          onStartTimeChange: function(n,o) {
            if(n && moment(n).format() !== moment(o).format()) {
              $scope.resourceAvailability.processResources($scope.resourceAvailability.resourcesList);
            }
          },

          onStartHourChange: function(n,o) {
            if(n && n!==o) {
              $scope.resourceAvailability.processResources($scope.resourceAvailability.resourcesList);
            }
          },

          onDurationChange: function(n,o) {
            if (n && n!==o) {
              $scope.resourceAvailability.processResources($scope.resourceAvailability.resourcesList);
            }
          },

          onSelectedResourceItemChange: function(n,o) {
            var self = $scope.resourceAvailability,
                selectedResourceRequestCopy = $.extend({}, self.selectedResourceRequest);

            if (n.resourceId || o.resourceId) {

              if (n.resourceId) {
                if (self.type === 'event'){
                  $scope.selectedResourcesList[selectedResourceRequestCopy.id] = n.resourceId;
                } else {
                  $scope.selectedResourcesList[selectedResourceRequestCopy.id] = n;
                }

                selectedResourceRequestCopy.resourceId = n.resourceId;
                selectedResourceRequestCopy.resourceName = n.resourceName;
                selectedResourceRequestCopy.name = n.resourceName;

                if (n.available && !n.conflicts) {
                  selectedResourceRequestCopy.status = AVAILABILITY.available.status;
                  selectedResourceRequestCopy.statusIcon = AVAILABILITY.available.icon;
                  selectedResourceRequestCopy.statusLabel = AVAILABILITY.available.label;
                } else {
                  selectedResourceRequestCopy.status = AVAILABILITY.unavailable.status;
                  selectedResourceRequestCopy.statusIcon = AVAILABILITY.unavailable.icon;
                  selectedResourceRequestCopy.statusLabel = AVAILABILITY.unavailable.label;
                }
              } else if (!n) {
                $scope.selectedResourcesList[selectedResourceRequestCopy.id] = false;

                delete selectedResourceRequestCopy.resourceId;
                delete selectedResourceRequestCopy.resourceName;

                selectedResourceRequestCopy.name = AVAILABILITY.unassign.label;
                selectedResourceRequestCopy.status = AVAILABILITY.unassign.status;
                selectedResourceRequestCopy.statusIcon = AVAILABILITY.unassign.icon;
                selectedResourceRequestCopy.statusLabel = AVAILABILITY.unassign.label;
              }
              self.replaceResourceList(selectedResourceRequestCopy);
            }

            self.processSummary();
          }
        };

        $scope.resourceAvailability.init();

      }]

    };

}]);
